import {Component, EventEmitter, Input, Output} from '@angular/core';
import {App, NavController, NavParams, Tab, Tabs, ViewController} from 'ionic-angular';

import {CONFIG} from "../../app/config";
import {Util} from "../../app/util";
import {DataService} from "../../providers/data-service";
import {MessageService} from "../../providers/message-service";
import {LogadoService} from "../../providers/logado-service";

@Component({
    selector: 'tab-menu',
    templateUrl: 'tab-menu.html',
    providers: []
})

export class TabMenu {

    tabID: string;
    tabs: string;
    tab: number;

    config: any;
    logado: any;

    akkjson = (window as any).handappMainInstance.appjson;

    @Input() titulo: string;
    @Input() tipo: string;

    @Output('onTabClick') tabClick: EventEmitter<any> = new EventEmitter();
    @Output('onTabPress') tabPress: EventEmitter<any> = new EventEmitter();
    @Output('onTabChange') tabChange: EventEmitter<any> = new EventEmitter();
    @Output('onAdicionar') adicionar: EventEmitter<any> = new EventEmitter();
    @Output('onTabSaved') tabSaved: EventEmitter<any> = new EventEmitter();
    @Output('onCancelar') cancelar: EventEmitter<any> = new EventEmitter();

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public app: App, public dataService: DataService, public messageService: MessageService,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.tab = 0;

        // quando usa o .select ou clica na aba original, recebe esse evento desde que a aba seja alterada
        // para click em aba já aberta, funciona somente se clicado no TabMenu
        this.messageService.get('tab.selected')
            .subscribe(data => {

                if (this.tabID) {
                    if (data.tabsNew == this.tabID.split('-')[1].substr(1) && data.indexNew == this.tabID.split('-')[2]) {
                        this.tabChange.emit(data);
                    }
                }

            });

    }

    ngOnInit() {

        if (!this.navCtrl.parent || this.navCtrl.parent._componentName !== 'tabs') {
            return;
        }

        let intervalVerif: number = setInterval(() => {

            if (!this.app.getRootNavs()[0] || !this.app.getRootNavs()[0].getActiveChildNavs()[0]) {
                clearInterval(intervalVerif);
                return;
            }

            // abas principais
            let parentNavCtrl: Tab = this.app.getRootNavs()[0].getActiveChildNavs()[0].getActiveChildNavs()[0];

            // dash
            if (parentNavCtrl && parentNavCtrl.getActiveChildNavs().length) {
                parentNavCtrl = parentNavCtrl.getActiveChildNavs()[0].getActiveChildNavs()[0];
            }

            // menu
            if (parentNavCtrl && parentNavCtrl.getActiveChildNavs().length && this.tipo && (this.tipo.indexOf('KRS_') > -1 || this.tipo.indexOf('ADM_') > -1)) {
                parentNavCtrl = parentNavCtrl.getActiveChildNavs()[0].getActiveChildNavs()[0];
            }

            // supertabs
            if (parentNavCtrl && parentNavCtrl.parent.id == 'super-tabs-feed') {
                parentNavCtrl = parentNavCtrl.parent.parent;
            }

            //console.log(parentNavCtrl);

            if (parentNavCtrl && parentNavCtrl.getNativeElement()) {
                this.tabID = parentNavCtrl.getNativeElement().id;
                if (this.tabID.split('-').length > 1) {
                    //console.log(this.tabID.split('-').length, this.tabID);
                    this.tabs = this.tabID.split('-')[1].substr(1);
                    this.tab = parseInt(this.tabID.split('-')[2]);
                    clearInterval(intervalVerif);
                }
            }

        }, 500);

    }

    selectTab(tabIndex: number, tabsIndex: number = 0, press: boolean = false) {

        let atual = this.dataService.get('tabselected');
        let root = !this.navCtrl.canGoBack();
        //let work = (this.akkjson && this.akkjson.hotwork);
        if (atual == tabIndex && tabIndex == 1 && !press && root && this.logado.Profile.ProfileZito) {
            this.messageService.get('webster.toggle').next(null);
        }


        //#AKI-E-LAH#



        let tabsList: Tabs[] = [];

        let navCtrl: any = this.navCtrl;
        while (navCtrl = navCtrl.parent) {
            if (navCtrl._componentName == 'tabs') tabsList.push(navCtrl);
        }

        tabsList.reverse();

        let value = {index: tabIndex, tabsIndex: tabsIndex};
        let cleck = (tabsList[tabsIndex] && tabIndex == tabsList[tabsIndex].getIndex(tabsList[tabsIndex].getActiveChildNavs()[0]));

        if (!press && cleck) this.tabClick.emit(value);
        if (press) this.tabPress.emit(value);

        //Grava Tab Selecionada
        //#AKI-E-LAH# - Troca no click cai aqui!
        this.dataService.set('tabselected', tabIndex);

        tabsList[tabsIndex].select(tabIndex);

    }

    adicionarBt() {
        this.adicionar.emit();
    }

    _emitSaved() {

        this.tabSaved.emit();

    }

    cancelarBt() {
        this.cancelar.emit();
    }

    isCheckin() {
        return !!(window as any).handappMainInstance.appjson.checkin;
    }

    tabcolor(pos: 'L' | 'C' | 'R', txt: 'ICO' | 'PIN' | 'COR' | 'BCG'): string {

        let brandus = (this.config.data.brandap ? this.config.data.brandap : this.config.spotus);
        let paybook = (window as any).handappMainInstance.appjson.checkin;

        let root = this.util.isRoot();
        let cora = (!paybook ? null : paybook.Branded.BrandedCora);
        let icon = (!paybook ? brandus.BrandedIcon : paybook.Branded.BrandedIcon);
        let ngtv = this.config.negative(cora);

        if (txt == 'PIN') {

            if (pos == 'C' && this.tab == 1) return (paybook ? cora : 'CorMilk');
            if (pos == 'C' && this.tab != 1) return (paybook ? cora : 'CorDash');

        }

        if (txt == 'COR') {

            if (pos == 'L' && this.tab == 0) return brandus.BrandedCora;
            if (pos == 'L' && this.tab == 1) return (paybook && root ? ngtv : 'CorDash');
            if (pos == 'L' && this.tab == 2) return 'CorDash';

            if (pos == 'C' && this.tab == 1) return (paybook ? cora : brandus.BrandedCora);
            if (pos == 'C' && this.tab != 1) return (paybook ? cora : 'CorHold');

            if (pos == 'R' && this.tab == 0) return 'CorDash';
            if (pos == 'R' && this.tab == 1) return (paybook && root ? ngtv : 'CorDash');
            if (pos == 'R' && this.tab == 2) return brandus.BrandedCora;

        }

        if (txt == 'BCG' && pos == 'C') return this.tab == 1 ? (paybook ? 'CorMilk' : brandus.BrandedCora) : 'CorMilk';
        if (txt == 'ICO' && pos == 'C') return icon;

    }

}






// WEBPACK FOOTER //
// ./src/components/tab-menu/tab-menu.ts